export default "__VITE_ASSET__7feefb09__"